export enum COLOUR_SELECTION {
  RED = 'Red',
  BLUE = 'Blue',
  GRAY = 'Gray',
  WHITE = 'White',
}

export enum RICH_TEXT_ALIGNMENT {
  LEFT = 'Left',
  CENTRE = 'Centre',
  RIGHT = 'Right',
}

export enum SUB_CATEGORY_FONT_COLOUR {
  WHITE = 'White',
  BLACK = 'Black',
}

export enum PAGE_TEMPLATE_TYPE {
  MARQUEE_BANNER = 'ComponentMarqueeBanner',
  HTML_EMBED = 'ComponentHtmlEmbed',
  PICTURE_PANEL = 'ComponentPicturePanel',
  VIDEO_PANEL = 'ComponentVideoPanel',
  RICH_TEXT_PANEL = 'ComponentRichTextPanel',
  BANNER = 'BannerCarouselImagesCollection',
  COLUMN_PANEL = 'ComponentColumnPanel',
  CAROUSEL = 'BannerCarousel',
  CATEGORY_PANEL = 'ComponentCategoryPanel',
  PRODUCT_PANEL = 'ComponentProductPanel',
  CONTENT_CARD = 'ContentCard',
  CONTENT_TILE_CONTAINER = 'ContentTileContainer',
  HEADING = 'Heading',
  CONTENT_CARD_CONTAINER = 'ContentCardContainer',
  PROPOSITION_CARD_CONTAINER = 'PropositionCardContainer',
  HELP_CHAT = 'HelpChat',
}

export enum PANEL_CONTENT_TYPE {
  PICTURE_PANEL = 'ComponentPicturePanel',
  VIDEO_PANEL = 'ComponentVideoPanel',
  HTML_EMBED = 'ComponentHtmlEmbed',
  RICH_TEXT_PANEL = 'ComponentRichTextPanel',
}
